import lightDefault from './default';
import lightCompact from './compact';
import lightDefaultNative from './native';

export default {
    default: lightDefault,
    compact: lightCompact,
    native: lightDefaultNative
};
